export default "__VITE_ASSET__B8dw6Kkg__"